//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { rgba } from 'polished';

import { UnisonColor } from '@bvengineering/unison-core';

/**
 * A strict typing of the `rgba` helper from polished. Returns an rgba string for a
 * given hex code out of our theme set and a given opacity (in decimal form from 0-1),
 * to implement specs like "primary color at 10%".
 */
export const getRgbaForThemeHex = (color: UnisonColor, opacity: number) =>
  rgba(color, opacity);
